<template>
  <div class="criterio-select-lojas">
    <span class="criterio-subtitle">Valores do atributo (OU)</span>
    <v-row>
      <v-col class="py-0 pt-1" align="center">
        <v-autocomplete
          v-model="selectedOptionsValues"
          outlined
          :disabled="loadingInitialState"
          :loading="loadingInitialState"
          :items="availableOptions"
          label="Opções"
          item-text="label"
          item-value="value"
          multiple
          hide-details
        >
          <template #selection="{ index }"
            ><span v-if="index === 0">{{ getAutocompleteInputValue }}</span></template
          >
        </v-autocomplete>
        <v-chip-group column active-class="primary--text">
          <v-chip v-for="(option, index) in selectedOptions" :key="`${index}-option`" small close :ripple="false" @click:close="removeOption(option)">
            <span>{{ option.label }}</span>
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { QUERY_DYNAMIC_ATTRIBUTES } from '@/modules/clientes/segmentation/graphql'
import { mapState } from 'vuex'

export default {
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    values: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
    componentParams: {
      type: Object,
      default: () => {
        return {}
      },
    },
    currentBranch: {
      type: Array,
      default: () => {
        return []
      },
    },
  },

  data: () => ({
    selectedOptionsValues: [],
    dynamicAttributes: [],
    loadingInitialState: false,
  }),

  computed: {
    ...mapState({}),
    getAutocompleteInputValue() {
      if (this.selectedOptionsValues.length === this.availableOptions.length) return 'Todos'
      if (this.selectedOptionsValues.length > 1) return `${this.selectedOptionsValues.length} selecionados`
      if (!this.selectedOptionsValues.length) return '0 selecionados'
      const selectedIndex = this.availableOptions.findIndex((item) => item.value === this.selectedOptionsValues[0])
      return `${this.availableOptions[selectedIndex].label}`
    },
    selectedDynamicAttributeOnBranch() {
      return this.currentBranch.find((node) => node.component === 'CriterioSelectDynamicAttribute')?.value
    },
    availableOptions() {
      return this.dynamicAttributes.find((attribute) => attribute._id === this.selectedDynamicAttributeOnBranch?._id)?.options || []
    },
    tooltipPrimaryButton() {
      return this.disableSave
    },
    tooltipPrimaryButtonMessage() {
      return this.disableSave ? 'Não é possível alterar um segmento estático' : ''
    },
    selectedOptions() {
      return this.availableOptions.filter((option) => this.selectedOptionsValues.includes(option.value)).map(({ value, label }) => ({ value, label }))
    },
  },

  watch: {
    selectedOptionsValues(selectedOptionsValues) {
      const selectedOptions = this.availableOptions
        .filter((option) => selectedOptionsValues.includes(option.value))
        .map(({ value, label }) => ({ value, label }))
      this.$emit('input', {
        currentValue: selectedOptions,
        currentChildren: this.values[0],
        currentIndex: this.currentIndex,
        affectsChildren: true,
      })
      this.validate()
    },
  },

  async mounted() {
    await this.queryDynamicAttributes()
    if (this.initialValue && this.initialValue.length) {
      this.setInitialState(this.initialValue)
    }
    this.validate()
  },

  methods: {
    removeOption(item) {
      const index = this.selectedOptionsValues.indexOf(item.value)
      if (index >= 0) this.selectedOptionsValues.splice(index, 1)
    },
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      return Boolean(this.selectedOptionsValues && this.selectedOptionsValues.length)
    },

    async queryDynamicAttributes() {
      try {
        this.loadingInitialState = true
        const {
          data: {
            dynamicAttributes: { dynamicAttributes },
          },
        } = await this.$apollo.query({
          query: QUERY_DYNAMIC_ATTRIBUTES,
        })
        this.dynamicAttributes = dynamicAttributes
      } catch {
        this.$snackbar({ message: 'Falha ao comunicar com o servidor.' })
      }
      this.loadingInitialState = false
    },

    setInitialState(selectedOptions) {
      this.selectedOptionsValues = selectedOptions.map((option) => option.value)
    },
  },
}
</script>

<style lang="scss">
.criterio-select-lojas {
  .select-container {
    padding: 0 15px;
  }
}
</style>
